// extracted by mini-css-extract-plugin
export default {"h1":"Nav_h1__bj75Z","h2":"Nav_h2__MG+bM","h3":"Nav_h3__42FFb","h4":"Nav_h4__cyce6","h5":"Nav_h5__jIVH9","h6":"Nav_h6__4Ji94","nav":"Nav_nav__igXZQ","pillar":"Nav_pillar__zCscO"};